import useClickOutsideHook from './useClickOutside'

export const useClickOutside = useClickOutsideHook
